import React, { useEffect } from 'react';
import { RxCross2 } from 'react-icons/rx';

interface DeleteFundRequestModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isDeleting?: boolean;
    fundRequestId: number;
}

const DeleteFundRequestModal: React.FC<DeleteFundRequestModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isDeleting = false,
    fundRequestId,
}) => {
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (keyCode === 27 && !isDeleting) onClose(); // ESC key (disabled while deleting)
        };
        if (isOpen) {
            document.addEventListener('keydown', keyHandler);
        }
        return () => document.removeEventListener('keydown', keyHandler);
    }, [isOpen, onClose, isDeleting]);

    if (!isOpen) return null;

    return (
        <div
            className='fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5'
            onClick={!isDeleting ? onClose : undefined}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
            >
                <button
                    className='absolute right-4 top-4 text-gray-600 hover:text-gray-900'
                    onClick={onClose}
                    disabled={isDeleting}
                >
                    <RxCross2 />
                </button>
                <div className='p-8'>
                    <div className='mb-4'>
                        <h2 className='mb-[30px] text-[22px] font-bold'>
                            Delete Fund Request?
                        </h2>
                    </div>

                    <p className='mb-[30px]'>
                        Are you sure you want to delete fund request <strong>#{fundRequestId}</strong>? This action cannot be undone.
                    </p>

                    <div className='flex justify-start space-x-4'>
                        <button
                            onClick={onClose}
                            disabled={isDeleting}
                            className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isDeleting}
                            className='rounded-full bg-danger px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-white transition-colors duration-500 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            {isDeleting ? 'Deleting...' : 'Delete'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteFundRequestModal;